import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type TenantStaffDto = {
  id: string;
  userId: string;
  email: string;
  role: string;
  isActive: boolean;
  firstName?: string;
  lastName?: string;
  lastLoginAt?: string;
};

export type CreateTenantStaffPayload = {
  email: string;
  role: string;
  firstName?: string;
  lastName?: string;
};

@Injectable({ providedIn: 'root' })
export class TenantUsersService {
  constructor(private readonly api: ApiService) {}

  list() {
    return this.api.get<ApiEnvelope<TenantStaffDto[]>>('tenant/users').pipe(map((r) => r.data));
  }

  create(payload: CreateTenantStaffPayload) {
    return this.api.post<ApiEnvelope<TenantStaffDto>>('tenant/users', payload).pipe(map((r) => r.data));
  }

  updateStatus(id: string, isActive: boolean) {
    return this.api
      .patch<ApiEnvelope<TenantStaffDto>>(`tenant/users/${id}/status`, { isActive })
      .pipe(map((r) => r.data));
  }
}
